module.exports = __webpack_public_path__ + "img/cert-product.98204af.webp";